/**
 * Login Component
 * 
 * Provides authentication interface for users to sign in to the admin portal.
 * Integrates with Clerk authentication service.
 */
import React from 'react';
import { SignIn } from '@clerk/clerk-react';

// Removed UI component imports for Card, CardContent, CardHeader, CardTitle
// API/service imports
// import { useAuthContext } from './useAuthContext'; // userRole is not used here anymore

/**
 * Login Component
 * 
 * @returns {JSX.Element} Rendered login component or redirect if already authenticated
 */
const Login: React.FC = () => {
  // const { userRole } = useAuthContext(); // Not used

  return (
    // AuthLayout provides the card and centering.
    // This component now just provides the content for that card.
    <>
      <div className="text-center mb-6"> {/* Increased bottom margin for better spacing */} 
        <h1 className="text-2xl font-bold text-primary-900 tracking-tight">
          Recurring Value Podcast Admin
        </h1>
        <p className="text-sm text-muted-foreground mt-2">
          Sign in to access the admin portal
        </p>
      </div>
      <SignIn 
        appearance={{
          elements: {
            formButtonPrimary: 'bg-primary-600 hover:bg-primary-700 text-white',
            footerAction: 'text-primary-600 hover:text-primary-700',
            card: 'shadow-none',
            headerTitle: 'text-2xl font-bold',
            headerSubtitle: 'text-gray-600',
            socialButtonsBlockButton: 'border-gray-300',
            dividerText: 'text-gray-600',
            formFieldLabel: 'text-gray-700',
            formFieldInput: 'border-gray-300',
            alternativeMethodsBlockButton: 'text-gray-600 hover:text-gray-700'
          }
        }}
        redirectUrl="/"
      />
    </>
  );
};

export default Login;
